import React from 'react';
import LazyLoad from 'react-lazyload';
import { string } from 'prop-types';
import * as styles from './styles/styles.module.scss';

const ActivityRiverItem = ({ url, imgSrc, title }) => {
  return (
    <div className={styles.container}>
      <a href={url}>
        <LazyLoad>
          <img src={imgSrc} className={styles.image} alt={title} />
        </LazyLoad>
        <div className={styles.title}>{title}</div>
      </a>
    </div>
  );
};

ActivityRiverItem.propTypes = {
  url: string.isRequired,
  imgSrc: string.isRequired,
  title: string
};

ActivityRiverItem.defaultProps = {
  title: ''
};

export default ActivityRiverItem;
